<template>
  <div>
    <a-range-picker
      :allowClear="false"
      :placeholder="
        mode === 'year' ? ['开始年', '结束年'] : ['开始月', '结束月']
      "
      style="width: 100%"
      :mode="newMode"
      :format="format"
      v-model="date"
      :open="open"
      @click.native="open = true"
      @panelChange="handlePanelChange"
    >
      <div slot="renderExtraFooter" style="width: 520px;text-align: right">
        <a-button type="primary" size="small" @click="open = false">
          确定
        </a-button>
      </div>
    </a-range-picker>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    format: {
      type: String,
      required: true,
    },
    mode: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      newMode: [],
      open: false,
      date: null,
    }
  },
  watch: {
    mode: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.newMode = [newValue, newValue]
        }
      },
    },
  },
  methods: {
    handlePanelChange(value, mode) {
      this.date = value
      if (this.mode === 'month') {
        this.newMode = [
          mode[0] === 'date' ? this.mode : mode[0],
          mode[1] === 'date' ? this.mode : mode[1],
        ]
      } else if (this.mode === 'year') {
        this.newMode = [this.mode, this.mode]
      }

      this.$emit(
        'input',
        value.map(item => moment(item).format(this.format)),
      )
    },
  },
}
</script>
